import React, { useEffect, useRef, useState } from 'react'
import './home.css'
// import Navigation from '../../components/navigation'
// import Footer from '../../components/footer'
import { THEMES } from '../../constatnts'
import Spacer from 'src/components/Spacer'
import PromoBlock from 'src/components/PromoBlock'
import CountUp from 'react-countup'
import { useIsInViewportOnce } from 'src/hooks'
import { useTranslation } from 'react-i18next'
import { Button, Dialog, IconButton, Menu, MenuItem } from '@mui/material'
import { Form } from 'src/components/form'
import { useNavigate } from 'react-router-dom'
import Navigation from './navigation'
import Footer from './footer'

const Intersector = ({ children }) => {
  const someRef = useRef(null)
  const isInViewport = useIsInViewportOnce(someRef)

  return <div ref={someRef}>{isInViewport && children}</div>
}

export const EducationmutualPage = () => {
  const { t } = useTranslation()
  const [requestDemoModalOpen, setRequestDemoModalOpen] = useState(false)
  const btn = useRef(null)
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const handleClick = r => {
    setAnchorEl(r.currentTarget)
  }

  const handleClose = route => {
    if (route) {
      navigate(route)
    }
    setAnchorEl(null)
  }

  const navigate = useNavigate()

  useEffect(() => {
    requestDemoModalOpen ? (document.body.style.position = 'fixed') : (document.body.style.position = 'relative')
    requestDemoModalOpen ? (document.body.style.width = '100vw') : (document.body.style.width = '100%')
  }, [requestDemoModalOpen])

  const isMobile = window.innerWidth < 769

  return (
    <div className='em-page'>
      <Navigation
        theme={THEMES.dark}
        onOpenDemoModal={() => {
          setRequestDemoModalOpen(true)
        }}
      />
      <section className='dark heading-section'>
        <div className='hide mob-show home-mob-main-img'></div>
        <div className='container'>
          <div className='row row-center mob-column-reverse '>
            <div className='column column-start one-of-2 mob-fullwidth' style={{ maxWidth: 500 }}>
              <h1 className=''>Education Mutual Cyber, in partnership with Gallagher Cyber Defence Centre</h1>

              <p
                className='heading-description mw371 mom-mw305'
                style={{ marginTop: '33px', color: '#4A4A4A', maxWidth: 500 }}
              >
                Gallagher’s Cyber Defence Centre is a collection of tools and services for Gallagher clients who want to
                take a proactive and continuous approach to managing their cyber risk. It includes access to cyber risk
                specialists and automated security technology to help you defend your organisation against cyber
                incidents.
              </p>

              <Button
                className='mob-fullwidth mob-font-16'
                sx={{
                  mb: 2,
                  background: '#11552b',
                  borderRadius: 0,
                  padding: '16px 45px',
                  cursor: 'pointer',
                  color: '#fff',
                  fontSize: isMobile ? '16px' : '20px',
                  '&:hover': {
                    background: '#19703a'
                  }
                }}
                ref={btn}
                onClick={() => navigate('/educationmutual/activate/registration')}
                variant='dark'
                size='md'
              >
                Activate
              </Button>
              <Button
                className='mob-fullwidth mob-font-16'
                size='md'
                onClick={() => setRequestDemoModalOpen(true)}
                variant='dark'
                sx={{
                  background: '#11552b',
                  borderRadius: 0,
                  padding: '16px 45px',
                  cursor: 'pointer',
                  color: '#fff',
                  fontSize: isMobile ? '16px' : '20px',
                  '&:hover': {
                    background: '#19703a'
                  }
                }}
              >
                Book a demo
              </Button>
            </div>
          </div>
        </div>
      </section>
      <section className='header-to-dark darker padding140-150 mob-padding-54-35 box-shadow'>
        <div className='container'>
          <div className='column column-center'>
            <h2 className='text-center mb100 mob-mb-73 mw900 mob-mw341 mob-sato-26'>{t('home.setction2title')}</h2>
          </div>
          <div className='row space-between mob-column mob-margin-0'>
            <div className='column column-start one-of-4 mob-fullwidth mob-mb-40' style={{ maxWidth: 205 }}>
              <div className='gradient-text text-center big-num '>
                {' '}
                <Intersector>
                  <CountUp end={93} />%
                </Intersector>
              </div>
              <p className='font20 mob-font14 mob-font500 lh12 mw279'>{t('home.setction2text1')}</p>
            </div>

            <div className='column column-start one-of-4 mob-fullwidth mob-mb-40' style={{ maxWidth: 205 }}>
              <div className='gradient-text text-center big-num '>
                <Intersector>
                  <CountUp end={82} />%
                </Intersector>
              </div>
              <p className='font20 mob-font14 mob-font500 lh12 mw339 mob-mw299'>{t('home.setction2text2')}</p>
            </div>

            <div className='column column-start one-of-4 mob-fullwidth mob-mb-20' style={{ maxWidth: 205 }}>
              <div className='gradient-text text-center big-num '>
                <Intersector>
                  <CountUp duration={3} end={30} />%
                </Intersector>
              </div>
              <p className='font20 mob-font14 mob-font500 lh12 mw279 mob-mw245'>{t('home.setction2text3')}</p>
            </div>

            <div className='column column-start one-of-4 mob-fullwidth mob-mb-20' style={{ maxWidth: 205 }}>
              <div className='gradient-text text-center big-num '>
                <Intersector>
                  $<CountUp duration={3} end={4} />
                  .45M
                </Intersector>
              </div>
              <p className='font20 mob-font14 mob-font500 lh12 mw279 mob-mw245'>{t('home.setction2text4')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className='dark pt90 pb50'>
        <div className='container'>
          <div className='column'>
            <div className=' mb40 mob-mb-20 content-box secure-humans-backgound'>
              <div className='row row-center space-between mob-column'>
                <div className='hide mob-show' style={{ height: 230 }}></div>
                <Spacer />
                <div className='mob-mb-20 one-of-2 mob-fullwidth content-box-text'>
                  <h3 style={{ maxWidth: '419px', fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                    Building Cyber Resilience Together
                  </h3>
                  <div className='title-underline'></div>
                  <p className='font18-400  mob-mb-20' style={{ color: '#5D5D5D', fontFamily: 'Source Sans 3' }}>
                    The biggest contributor to a cyber incident is human vulnerability. Each month, we will host a
                    series of cybersecurity training webinars designed for your employees at all levels of
                    understanding. Throughout the year, your staff can be trained by our specialist cybersecurity team
                    in the role they can play in defending your organisation. Topics will include boundary control,
                    email security and phishing, working from home, data protection and more.
                  </p>
                </div>
              </div>
            </div>

            <div className='row mob-column' style={{ gap: 40, marginBottom: 40 }}>
              <div className='  content-box one-of-2 mob-fullwidth'>
                <div className='row row-center space-between mob-column'>
                  <div className=' '>
                    <h3 style={{ fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                      Vulnerability Scanning
                    </h3>
                    <div className='title-underline'></div>
                    <p className='font18-400  ' style={{ color: '#5D5D5D', fontFamily: 'Source Sans 3' }}>
                      Our Cyber Defence team will monitor your external boundaries and provide you with updates as to
                      the known vulnerabilities in your technology portfolio. This report will outline where your low-,
                      medium- and high-risk technology vulnerabilities reside.
                    </p>
                  </div>
                </div>
              </div>

              <div className='  content-box one-of-2 mob-fullwidth'>
                <div className='row row-center space-between mob-column-reverse'>
                  <div className=' '>
                    <h3 style={{ fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                      Threat Intelligence Webinars
                    </h3>
                    <div className='title-underline'></div>
                    <p className='font18-400  ' style={{ color: '#5D5D5D', fontFamily: 'Source Sans 3' }}>
                      Forewarned is forearmed. As a cyber insurance broker, we deal with a huge amount of claims and
                      from this, we gain extensive intelligence on the latest threats and methods of attack. We can
                      provide real-time updates on where your organisation needs to be focusing its cyber defence
                      efforts.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className=' mb40 mob-mb-20 content-box newsletter-backgound'>
              <div className='row row-center space-between mob-column'>
                <div className='hide mob-show' style={{ height: 260 }}></div>
                <div className='mob-mb-20 one-of-2 mob-fullwidth mob-content-box-text'>
                  <h3 style={{ fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                    Gallagher Cyber Risk Matters Newsletter
                  </h3>
                  <div className='title-underline'></div>
                  <p
                    className='font18-400  mob-mb-20'
                    style={{ color: '#5D5D5D', fontFamily: 'Source Sans 3', maxHeight: 508 }}
                  >
                    We will send you regular email updates on the latest cyber thinking so that you can stay informed.
                    We are in the age of information, and these key insights can support you to make key changes and
                    adaptions to your security efforts.
                  </p>
                </div>
              </div>
            </div>

            <div className=' mb40 mob-mb-20 content-box virtual-cisco-backgound'>
              <div className='row row-center space-between mob-column'>
                <div className='hide mob-show' style={{ height: 230 }}></div>
                <Spacer />
                <div className='mob-mb-20 one-of-2 mob-fullwidth content-box-text'>
                  <h3 style={{ maxWidth: '419px', fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                    Virtual CISO
                  </h3>
                  <div className='title-underline'></div>
                  <p className='font18-400  mob-mb-20' style={{ color: '#5D5D5D', fontFamily: 'Source Sans 3' }}>
                    Gain access to a Virtual Chief Information Security Officer (CISO) who will provide guidance and
                    support. Leverage their expertise to assess your current cybersecurity posture, develop strategies
                    and address any concerns or questions you may have.
                  </p>
                </div>
              </div>
            </div>

            <div className='row mob-column' style={{ gap: 40, marginBottom: 40 }}>
              <div className='content-box one-of-2 mob-fullwidth'>
                <div className='row row-center space-between mob-column'>
                  <div className=' mob-fullwidth'>
                    <h3 style={{ maxWidth: '419px', fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                      Cyber Essentials
                    </h3>
                    <div className='title-underline'></div>
                    <p className='font18-400  ' style={{ color: '#5D5D5D', fontFamily: 'Source Sans 3' }}>
                      Through Gallagher, you can take advantage of lower prices on Cyber Essentials and IASME
                      accreditation. Cyber Essentials is the government-backed information security standard that offers
                      70-plus controls to better secure your network
                    </p>
                  </div>
                </div>
              </div>

              <div className='content-box one-of-2 mob-fullwidth'>
                <div className='row row-center space-between mob-column-reverse'>
                  <div className=' mob-fullwidth'>
                    <h3 style={{ maxWidth: '419px', fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                      Community Intelligence
                    </h3>
                    <div className='title-underline'></div>
                    <p className='font18-400  ' style={{ color: '#5D5D5D', fontFamily: 'Source Sans 3' }}>
                      You will be part of a community of security professionals where your contribution counts. You will
                      be invited to monthly discussions about key security concerns and live threats your organisation
                      needs to be aware of. We will be bringing forward thought leadership and solutions for network
                      configuration, technology optimisation, risk management and risk transfer. As a collective, we are
                      stronger together in the offensive efforts against cybercriminals.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className=' mb40 mob-mb-20 content-box other-services-backgound'>
              <div className='row row-center space-between mob-column'>
                <div className='hide mob-show' style={{ height: 270 }}></div>
                <div className='mob-mb-20 one-of-2 mob-fullwidth content-box-text'>
                  <h3 style={{ fontFamily: 'Roboto Slab' }} className='mob-font-20'>
                    Other Security Services
                  </h3>
                  <div className='title-underline'></div>
                  <p className='font18-400  mob-mb-20' style={{ color: '#5D5D5D', fontFamily: 'Source Sans 3' }}>
                    Take advantage of the wider security services the Gallagher Cyber Risk Management practice provides
                    and receive preferential pricing as a Gallagher Cyber Defence Centre member. Services such as
                    penetration testing, phishing simulations, ISO 27001, incident response planning, maturity
                    assessments and more are all available to you when you become part of our community.
                  </p>
                </div>
                <Spacer />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='dark mob-pb-20'>
        <PromoBlock
          buttonText={'Book a Demo'}
          onModalOpen={() => navigate('/educationmutual/activate/registration')}
          color={'#11552b'}
        >
          <p className='sato34 mb36 font500 mob-mw263 mob-font-24 text-center'>
            Start your journey with Gallagher.
            <br /> Connect with an expert.
          </p>
        </PromoBlock>
      </section>

      <Footer theme={THEMES.dark} />

      <Dialog
        sx={{ '& .MuiPaper-root': { width: 500 } }}
        onClose={() => setRequestDemoModalOpen(false)}
        open={requestDemoModalOpen}
      >
        <div className='row' style={{ padding: '10px 10px 0px 0px' }}>
          <Spacer />
          <IconButton onClick={() => setRequestDemoModalOpen(false)}>
            <svg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path d='M6.92358 6.75391L19.4236 19.2539' stroke='#444444' strokeWidth='1.75' strokeLinecap='round' />
              <path d='M6.92358 19.2461L19.4236 6.7461' stroke='#444444' strokeWidth='1.75' strokeLinecap='round' />
            </svg>
          </IconButton>
        </div>
        <Form color={'#11552b'} onClose={() => setRequestDemoModalOpen(false)} />
      </Dialog>
    </div>
  )
}
